var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2795 15.1221C23.2795 18.3443 20.6758 20.9554 17.4628 20.9554C14.2498 20.9554 11.6461 18.3442 11.6461 15.1221C11.6461 11.9 14.2498 9.28888 17.4628 9.28888C20.6758 9.28888 23.2795 11.9 23.2795 15.1221Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9196 22.8665C19.4239 24.2443 18.5929 26.1109 18.5929 28.122C18.5929 29.6997 19.1137 31.2109 20.0997 32.4775C20.2327 32.6553 20.2548 32.8775 20.1662 33.0664C20.0665 33.2553 19.8781 33.3775 19.6676 33.3775H7.3362C7.03706 33.3775 6.78223 33.1331 6.78223 32.8219V29.9108C6.78223 25.4884 10.372 21.8998 14.7705 21.8998H20.5538C20.7754 21.8998 20.986 22.0331 21.0635 22.2554C21.1521 22.4665 21.0969 22.7109 20.9196 22.8665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9743 27.979L28.8568 24.8526C28.5327 24.5276 28.0065 24.5276 27.6824 24.8526C27.3583 25.1776 27.3583 25.7054 27.6824 26.0304L29.3817 27.7346H21.7118C21.2534 27.7346 20.8809 28.1082 20.8809 28.5679C20.8809 29.0276 21.2534 29.4013 21.7118 29.4013H29.3817L27.6824 31.1054C27.3569 31.4318 27.3639 31.9832 27.7004 32.3013C28.0231 32.6054 28.5466 32.5957 28.8568 32.2846L31.9743 29.1582C32.2998 28.8318 32.2998 28.304 31.9743 27.979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b909e00e92a2dba0c0bc6518b491967a.svg";
export { ForwardRef as ReactComponent };